// removed by extract-text-webpack-plugin
module.exports = {"dots":"_3K131-Ry5E1egqlJPaK3L1","dash":"_36QIKv-qJMQIY4RRbJL0C1","number":"_1K68uKdxrzbfpKRJAIZ2k6","plus":"_3Z4Q-Di59B8I1xeEi5uk0L","isActive":"_1hUDXjjZTjDZ3q5tB_PmBY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ImageSlider/CarouselDecorator/CarouselDecorator.scss
 ** module id = 730
 ** module chunks = 0
 **/